<div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="1rempx">
  <a mat-raised-button routerLink="/giveaways/create" color="primary"
    >NUEVO SORTEO</a
  >
  <div class="d-flex align-items-center">
    <span class="mr-2">Estado: </span>
    <mat-form-field>
      <mat-select
        [(ngModel)]="selectedStatus"
        (selectionChange)="loadGiveawayListByStatus()"
      >
        <mat-option *ngFor="let state of states" [value]="state.value">
          {{ state.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>
<div fxLayout="column" fxLayoutAlign="start end" fxLayoutGap="1rem">
  <table mat-table [dataSource]="giveawaysList" class="table">
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef>ID</th>
      <td width="50" mat-cell *matCellDef="let el">{{ el.id }}</td>
    </ng-container>
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Nombre</th>
      <td mat-cell *matCellDef="let el">
        {{ el.name }}
      </td>
    </ng-container>
    <ng-container matColumnDef="drawTime">
      <th mat-header-cell *matHeaderCellDef>Fecha de sorteo</th>
      <td mat-cell *matCellDef="let el">
        {{ parseIsoToDateTime(el.draw_datetime) }}
      </td>
    </ng-container>
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef>Estado</th>
      <td mat-cell *matCellDef="let el">{{ getItemStatus(el.status) }}</td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      (click)="goToGiveawayDetail(row.id)"
      class="link-table"
    ></tr>
  </table>

  <mat-paginator
    [length]="totalRecords"
    [pageSizeOptions]="[10, 20, 50, 100]"
    showFirstLastButtons
  >
  </mat-paginator>
</div>
